import { template as template_cc038badc44d4de586ca26f713a5e0c3 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import StandardModal from 'eflex/components/standard-modal';
import BsForm from 'eflex/components/bs-form';
import { t } from 'ember-intl';
import { conditionalAutofocus } from 'eflex/modifiers';
import JemInstructionsConfiguration from 'eflex/components/jem/instructions/configuration';
import { fn } from '@ember/helper';
import { service } from '@ember/service';
class JemTabConfigModal extends Component {
    @service
    validationErrorNotifier;
    cancel = (station, closeModal)=>{
        station.rollbackAttributes();
        closeModal();
    };
    save = async (tab, station, closeModal)=>{
        if (tab.isInvalid) {
            this.validationErrorNotifier.sendErrors(tab);
            return;
        }
        await station.save();
        closeModal(tab);
    };
    static{
        template_cc038badc44d4de586ca26f713a5e0c3(`
    <StandardModal
      class="jem-tab-config-modal jem"
      @size="lg"
      @onConfirm={{fn this.save @tab @station @closeModal}}
      @onCancel={{fn this.cancel @station @closeModal}}
      ...attributes
    as |modal|>
      <modal.header @text={{@title}} />
      <modal.body>
        <BsForm @model={{@tab}} as |form|>
          <form.element
            @label={{t "name"}}
            @property="title"
            class="config-tab-name-title is-required"
            {{conditionalAutofocus @tab.isNew}}
          as |el|>
            <el.control class="config-tab-name" />
          </form.element>
        </BsForm>
        <div class="eflex-scroll row w-auto mt-3">
          <div class="col">
            <JemInstructionsConfiguration
              @jemConfiguration={{@tab}}
              @useEvent={{false}}
              @showCopyToAll={{false}}
            />
          </div>
        </div>
      </modal.body>

      <modal.footer/>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
}
export default JemTabConfigModal;
